const mutations = {
  setFormJson(state, formJsonObj) {
    state.formJson = formJsonObj;
  },
  setFormJsonLoading(state, loading) {
    state.formJsonLoading = loading;
  },
  setFormJsonError(state, formJsonError) {
    state.formJsonError = formJsonError;
  }
};

export default mutations;
